<div class="auction-content-body">
  <div class="card auction-content-main">
    <form
      [formGroup]="searchForm"
      class="auction-filter-wrapper d-flex align-items-center"
    >
      <div class="auction-filter-searchfield ng-star-inserted">
        <div>
          <div class="credential3__input-group ng-star-inserted">
            <span class="credential3__icon">
              <ion-icon name="search-outline" class="ion-lg"></ion-icon>
            </span>
            <input
              type="text"
              placeholder="VIN Number"
              formControlName="vin_number"
              name="Vin_Number"
              autocomplete="off"
              class="form-control credential3__icon-input"
              id="dt-inventory-search"
              (input)="searchProductsFromList($event)"
            />
          </div>
        </div>
      </div>

      <div class="auction-filter-searchfield ng-star-inserted">
        <div>
          <div class="credential3__input-group ng-star-inserted">
            <span class="credential3__icon">
              <ion-icon name="search-outline" class="ion-lg"></ion-icon>
            </span>
            <select
              formControlName="category"
              name="type"
              class="form-control credential3__icon-input"
              (change)="searchProductsFromList($event)"
            >
              <option selected disabled value="">Select vehicle type</option>
              <option value="2">Used</option>
              <option value="3">New</option>
            </select>
          </div>
        </div>
      </div>

      <div class="auction-filter-searchfield ng-star-inserted">
        <div>
          <div class="credential3__input-group ng-star-inserted">
            <span class="credential3__icon">
              <ion-icon name="search-outline" class="ion-lg"></ion-icon>
            </span>
            <select
              formControlName="status"
              name="status"
              class="form-control credential3__icon-input"
              (change)="searchProductsFromList($event)"
            >
              <option selected disabled value="">Select a status</option>
              <option value="pending">Pending</option>
              <option value="reserve">Reserve</option>
              <option value="unreserve">Unreserve</option>
              <option value="sold">Sold</option>
            </select>
          </div>
        </div>
      </div>

      <button
        *ngIf="isFilterMode"
        class="
          btn btn__main2
          button_right_space
          curved
          flex-shrink-0
          yellow
          ml-auto
          mr-2
        "
        (click)="resetFilter()"
      >
        Clear
      </button>
    </form>

    <div *ngIf="noFilterMode" class="mx-3">
      <p *ngIf="!tableData.length" class="m-0">No data found</p>
      <table datatable [dtOptions]="dtOptions" id="purchase-request">
        <thead>
          <tr>
            <th *ngFor="let thead of theads">{{ thead }}</th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </div>

    <div *ngIf="isFilterMode" class="mx-3">
      <p *ngIf="!tableData.length" class="m-0">No data found</p>
      <table datatable [dtOptions]="dtOptions2" id="purchase-request">
        <thead>
          <tr>
            <th *ngFor="let thead of theads">{{ thead }}</th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </div>
  </div>
</div>
